@if (!maintenanceService.active()) {
  <div class="cov-app">
    <!-- TODO: Add global elements like notifications -->
    <router-outlet></router-outlet>
  </div>

  <cov-user-centrics />
  <cov-google-tagmanager />
  <cov-walk-me />
} @else {
  <cov-maintenance />
}
